// Native popstate dispatch can run microtasks between listeners. Wait until all
// draft guards have accepted or restored the URL before React unmounts an editor.
export function subscribeNavigation(update) {
  let pending;
  const onPop = () => {
    clearTimeout(pending);
    pending = setTimeout(update, 0);
  };
  window.addEventListener('popstate', onPop);
  return () => {
    clearTimeout(pending);
    window.removeEventListener('popstate', onPop);
  };
}
